import ProfileBodyWithTabs from './ProfileBodyWithTabs.js'

export default ProfileBodyWithTabs
